import { Close } from "@mui/icons-material";
import {
  AppBar,
  Dialog,
  DialogContent,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Button from "../../../../components/Button";
import { useState } from "react";
import { useToast } from "../../../../hooks/useToast";

const REPORT_BASE_URL = "https://relatorio.qualificaurb.com.br";

const buildReportUrl = (collectionId: number) =>
  `${REPORT_BASE_URL}/?collectionId=${collectionId}`;

interface Props {
  collectionId: number;
  onClose: () => void;
}

export default function DownloadRelatorioModal(props: Props) {
  const { collectionId, onClose } = props;
  const [isCopied, setCopied] = useState<boolean>(false);
  const { toast } = useToast();

  return (
    <Dialog
      className="w-full"
      open
      fullScreen={false}
      onClose={onClose}
      PaperProps={{
        sx: { overflow: "hidden" },
      }}
    >
      <AppBar className="!bg-primary" sx={{ position: "relative" }}>
        <Toolbar className="flex">
          <IconButton
            className="!absolute"
            color="inherit"
            onClick={onClose}
            aria-label="Fechar"
          >
            <Close />
          </IconButton>
          <Typography className="!mx-auto" variant="h6" component="div">
            Gerar relatório
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ overscrollBehavior: "contain" }}>
        <p className="my-4 leading-relaxed text-muted">
          O relatório abre em uma nova aba. Copie o link se quiser compartilhar.
        </p>

        <div className="mt-8 flex flex-col gap-2 sm:flex-row">
          <a
            href={buildReportUrl(collectionId)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-center font-bold text-white transition-colors hover:bg-primaryDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Abrir relatório
          </a>
          <Button
            variant="outlined"
            onClick={() => {
              try {
                navigator.clipboard.writeText(buildReportUrl(collectionId));
                setCopied(true);
                toast({
                  message: "Link copiado com sucesso",
                  type: "success",
                });
                setTimeout(() => {
                  setCopied(false);
                }, 1000);
              } catch (error) {
                toast({
                  message: "Não foi possível copiar o link. Copie o endereço manualmente.",
                  type: "error",
                });
              }
            }}
          >
            {!isCopied ? "Copiar link" : "Link copiado"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
